// import { OrganizationSchema } from '@/components/main/seo/OrganizationSchema';
// import Footer from '@/themes/default/elements/footer/Footer';
// import Header from '@/themes/default/elements/Header/Header';
// import { ReactNode } from 'react';


// export default async function MainLayout({
//     children,
// }: Readonly<{
//     children: ReactNode;
// }>) {
//     return (
//         <>
//             <OrganizationSchema /> {/* ✅ Invisible - only for search engines to improve seo - because of the <script type="application/ld+json"> tag in the file */}
//             <Header />
//             <main className="flex flex-col min-h-[calc(100vh-72px)]">
//                 <div className="min-h-full">{children}</div>
//                 <Footer />
//             </main>
//         </>
//     );
// }


import { OrganizationSchema } from '@/components/main/seo/OrganizationSchema';
import Footer from '@/themes/default/elements/footer/Footer';
import Header from '@/themes/default/elements/Header/Header';
import MainContentWrapper from '@/themes/default/elements/Header/MainContentWrapper';
import { ReactNode } from 'react';


export default async function MainLayout({
    children,
}: Readonly<{
    children: ReactNode;
}>) {
    return (
        <>
            <OrganizationSchema />
            <Header />
            <main className="flex flex-col min-h-[calc(100vh-72px)]">
                <MainContentWrapper>{children}</MainContentWrapper>
                <Footer />
            </main>
        </>
    );
}